import React from 'react';

import classNames from 'classnames';
import { faHandshake, faHouseBuilding, faSign, faUsers } from '@fortawesome/pro-solid-svg-icons';
import Tooltip from 'components/tooltip';

import type { Activity } from 'bundles/apex/activities/types';
import type { Task } from 'bundles/apex/tasks/types';

import './styles.scss';

interface Props {
  className?: string;
  record: Task | Activity | string;
}

export default function TaskParentIcon({ className, record }: Props) {
  let icon;
  let tooltip;

  const parentType = typeof record === 'string' ? record : record.parentType;

  switch (parentType) {
  case 'Apex::Deal':
    icon = faHandshake;
    tooltip = 'Deal';
    break;
  case 'Backoffice::Contact':
    icon = faUsers;
    tooltip = 'Contact';
    break;
  case 'Project':
  case 'Listing':
    icon = faSign;
    tooltip = 'Listing';
    break;
  default:
    icon = faHouseBuilding;
    tooltip = 'Property';
  }

  return (
    <div className={`crm-record__parent-icon ${classNames(className)}`}>
      <Tooltip content={tooltip} dark icon={icon} iconClassName="fa-sm"/>
    </div>
  );
}
